import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { POLICY_INDEX } from "../content/policies";

const BRAND = "GoPrintPack™";
const DEFAULT = {
  title: `${BRAND} · Smart Platform For Print & Packaging`,
  desc: "Post your print or packaging requirement and get sealed bids from verified printers across India. Escrow-protected payments, GST invoices and blind shipping.",
};
const PAGES = {
  "/": DEFAULT,
  "/contact": { title: `Contact Us · ${BRAND}`, desc: "Talk to the GoPrintPack team about print and packaging sourcing, supplier onboarding, payments or support. Email, phone and WhatsApp." },
  "/partner": { title: `Partner with ${BRAND}`, desc: "Join India's print and packaging marketplace as a printer, design studio, material supplier or finishing partner, and win verified orders." },
  "/partner/printer": { title: `Printers & Converters · Partner with ${BRAND}`, desc: "Bid on verified print and packaging jobs that match your machines and capacity. Escrow-backed payouts and no chasing payments." },
  "/partner/studio": { title: `Design Studios · Partner with ${BRAND}`, desc: "Get paid design briefs for packaging, labels and print from brands across India. NDA-protected work and escrow-backed payouts." },
  "/partner/material": { title: `Material Suppliers · Partner with ${BRAND}`, desc: "Supply paper, board, inks and films to printers on GoPrintPack. Receive matched material requests and get paid through escrow." },
  "/partner/logistics": { title: `Finishing & Logistics Partners · ${BRAND}`, desc: "Offer lamination, foiling, die-cutting and delivery services to printers on GoPrintPack and grow with steady work." },
  "/about": { title: `About Us · ${BRAND}`, desc: "GoPrintPack.com is India's first tech-driven B2B marketplace for commercial printing and custom packaging, with real-time reverse auctions, automated pre-flight checks and secure escrow." },
  "/careers": { title: `Careers · ${BRAND}`, desc: "Help build India's digital platform for print and packaging. See open roles at GoPrintPack." },
  "/login": { title: `Sign in · ${BRAND}`, desc: "Sign in to your GoPrintPack workspace to post RFQs, review sealed bids or manage your production." },
  "/register": { title: `Create your account · ${BRAND}`, desc: "Create a free GoPrintPack account as a buyer, printer, design agency, material supplier or finishing partner." },
};
POLICY_INDEX.forEach(({ slug, title }) => {
  PAGES[`/${slug}`] = { title: `${title} · ${BRAND}`, desc: `Read the GoPrintPack ${title}: how we handle accounts, orders, payments and your data on our print and packaging marketplace.` };
});
const PRIVATE = ["/workspace", "/admin", "/auth", "/onboarding", "/printer", "/reset-password", "/forgot-password", "/materials"];

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", content);
};

export function SeoManager() {
  const { pathname } = useLocation();
  useEffect(() => {
    const path = pathname.replace(/\/+$/, "") || "/";
    const policy = path.startsWith("/policies/") ? PAGES[`/${path.split("/")[2]}`] : null;
    const page = PAGES[path] || policy || DEFAULT;
    const url = `${window.location.origin}${path === "/" ? "/" : policy ? `/${path.split("/")[2]}` : path}`;
    document.title = page.title;
    setMeta("name", "description", page.desc);
    setMeta("name", "robots", PRIVATE.some(p => path.startsWith(p)) || (!PAGES[path] && !policy) ? "noindex, nofollow" : "index, follow");
    setMeta("property", "og:title", page.title);
    setMeta("property", "og:description", page.desc);
    setMeta("property", "og:url", url);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:site_name", "GoPrintPack");
    setMeta("property", "og:image", `${window.location.origin}/logo.png`);
    setMeta("name", "twitter:card", "summary");
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) { link = document.createElement("link"); link.rel = "canonical"; document.head.appendChild(link); }
    link.href = url;
  }, [pathname]);
  return null;
}
